import React from "react";
import { useNavigate } from "react-router-dom";

import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";

function TrackingResults({ results }) {

    const navigate = useNavigate();

    const handleRowClick = (item) => {
        navigate(`/track-order/${item}`);
    };


    return (
        <div>
          
            <TableContainer
                component={Paper}
                elevation={1}
                sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    fontFamily: "Roboto",
                    mt: 7,
                    width: { xs: "100%", md: "60%" },
                    mx: "auto",
                }}
            >
                  <h5
            sx={{
                    mb: 7,

                }}
            >Mostrando últimos resultados</h5>
                <Table>
                    <TableHead sx={{ backgroundColor: "#00c67d" }}>
                        <TableRow>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                                Fecha de compra
                            </TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                                Id Orden
                            </TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                                ID referencia
                            </TableCell>
                            <TableCell sx={{ color: "#fff", fontWeight: "bold" }}>
                                Estado
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {results.map((item, index) => (
                            <TableRow
                                key={index}
                                hover
                                onClick={() => handleRowClick(item.id)}
                                sx={{
                                    cursor: "pointer",
                                    "&:hover": {
                                        backgroundColor: "#eafaf3",
                                    },
                                }}
                            >
                                <TableCell>{item.created_at || "—"}</TableCell>
                                <TableCell>{item.id || "—"}</TableCell>
                                <TableCell>{item.reference_id || "-"}</TableCell>
                                <TableCell
                                    sx={{
                                        fontWeight: 600,
                                        color:
                                            item.delivery?.status === "delivered"
                                                ? "#00c67d"
                                                : "#333",
                                    }}
                                >
                                    {item.delivery?.status || "Sin estado"}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default TrackingResults;
